/*
 * Bushnell CRO patch — July 2026
 * 1f  Mobile sticky add-to-cart bar on every PDP template
 * 1i  Predictive search in the search overlay (/search/suggest.json)
 * 1j  Register-your-device prompt on account order pages
 * 1k  LCP boost: eager-load + fetchpriority on the first buy-box image
 * 1l  Talk-to-an-expert card on high-ticket PDPs + sim/LM collections
 * Fail-safe: every module is wrapped so an error never breaks the page.
 */

/* ---- 1i Predictive search ---------------------------------------- */
(function () {
  function init() {
    try {
      var input = document.querySelector('.search-overlay-input');
      var overlay = document.querySelector('.search-overlay');
      if (!input || !overlay || overlay.querySelector('.bn-predictive')) return;
      var panel = document.createElement('div');
      panel.className = 'bn-predictive';
      panel.hidden = true;
      overlay.appendChild(panel);
      var timer = null;
      var lastQ = '';
      function imgUrl(u) {
        return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=88';
      }
      function esc(s) {
        return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
      }
      function money(p) {
        var n = parseFloat(p);
        return isNaN(n) ? '' : '$' + n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      }
      function renderResults(q, items) {
        if (!items.length) {
          panel.innerHTML = '<div class="bn-predictive__empty">No matches for \u201C' + esc(q) + '\u201D</div>';
          panel.hidden = false;
          return;
        }
        /* Logged-in group members see their discounted price (exposed via Liquid). */
        var gpPct = (typeof window.BN_GP_PCT === 'number' && window.BN_GP_PCT > 0) ? window.BN_GP_PCT : 0;
        function priceHtml(raw, rawCompare) {
          var base = parseFloat(raw);
          if (isNaN(base)) return '';
          if (gpPct > 0) {
            /* Discount off the compare-at (MSRP) when present, else the price -
               matches the cart transform and the product-card snippets. */
            var msrp = parseFloat(rawCompare);
            var discBase = (!isNaN(msrp) && msrp > base) ? msrp : base;
            var disc = discBase * (100 - gpPct) / 100;
            return '<span class="bn-predictive__price bn-predictive__price--sale">' +
              money(disc) + '<s class="bn-predictive__price-old">' + money(discBase) + '</s></span>';
          }
          return '<span class="bn-predictive__price">' + money(base) + '</span>';
        }
        panel.innerHTML =
          '<div class="bn-predictive__label">Products</div>' +
          items.map(function (p) {
            var img = p.featured_image && p.featured_image.url
              ? '<img src="' + imgUrl(p.featured_image.url) + '" alt="" loading="lazy" width="44" height="44">'
              : '<span class="bn-predictive__ph"></span>';
            return '<a class="bn-predictive__item" href="' + p.url + '">' + img +
              '<span class="bn-predictive__info">' +
              '<span class="bn-predictive__title">' + esc(p.title) + '</span>' +
              priceHtml(p.price, p.compare_at_price || p.compare_at_price_max || p.compare_at_price_min) +
              '</span><span class="bn-predictive__arrow">\u2192</span></a>';
          }).join('') +
          '<a class="bn-predictive__all" href="/search?q=' + encodeURIComponent(q) + '&type=product">See all results for \u201C' + esc(q) + '\u201D \u2192</a>';
        panel.hidden = false;
      }
      function fetchResults(q) {
        lastQ = q;
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=5&resources[options][unavailable_products]=last')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            if (q !== lastQ) return;
            var items = (data && data.resources && data.resources.results && data.resources.results.products) || [];
            renderResults(q, items);
          })
          .catch(function () {});
      }
      input.addEventListener('input', function () {
        var q = input.value.trim();
        clearTimeout(timer);
        if (q.length < 2) { panel.hidden = true; panel.innerHTML = ''; return; }
        timer = setTimeout(function () { fetchResults(q); }, 200);
      });
      document.addEventListener('click', function (e) {
        if (!overlay.contains(e.target)) { panel.hidden = true; }
      });
    } catch (err) { /* fail-safe */ }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ---- 1f Mobile sticky add-to-cart -------------------------------- */
(function () {
  function init() {
    try {
      var priceEl = document.querySelector('.bpdp-price [data-bpdp-price-current]');
      if (!priceEl) return;
      /* Find the real ATC button by label */
      var realBtn = null;
      document.querySelectorAll('button, input[type="submit"]').forEach(function (b) {
        if (realBtn) return;
        if (/add\s+to\s+cart/i.test(b.textContent || b.value || '')) realBtn = b;
      });
      if (!realBtn) return;
      /* Skip if the theme already renders its own sticky bar on this template */
      var existing = document.querySelectorAll('[class*="sticky"]');
      for (var i = 0; i < existing.length; i++) {
        if (/add\s+to\s+cart/i.test(existing[i].textContent || '') && existing[i] !== realBtn && !existing[i].contains(realBtn)) return;
      }
      var titleEl = document.querySelector('.bpdp-title, #MainContent h1');
      var bar = document.createElement('div');
      bar.className = 'bn-sticky-atc';
      bar.innerHTML =
        '<div class="bn-sticky-atc__meta">' +
        '<div class="bn-sticky-atc__title">' + (titleEl ? titleEl.textContent.trim() : '') + '</div>' +
        '<div class="bn-sticky-atc__price">' + priceEl.textContent.trim() + '</div>' +
        '</div>' +
        '<button type="button" class="bn-sticky-atc__btn">Add to Cart</button>';
      document.body.appendChild(bar);
      bar.querySelector('.bn-sticky-atc__btn').addEventListener('click', function () {
        realBtn.click();
      });
      /* Keep the sticky price in sync on variant change */
      new MutationObserver(function () {
        var p = bar.querySelector('.bn-sticky-atc__price');
        if (p) p.textContent = priceEl.textContent.trim();
      }).observe(priceEl, { childList: true, characterData: true, subtree: true });
      /* Show only after the real button scrolls above the viewport */
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          var e = entries[0];
          var passed = !e.isIntersecting && e.boundingClientRect.top < 0;
          bar.classList.toggle('bn-sticky-atc--visible', passed);
        }, { threshold: 0 }).observe(realBtn);
      } else {
        bar.classList.add('bn-sticky-atc--visible');
      }
    } catch (err) { /* fail-safe */ }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ---- 1l Talk-to-an-expert (high-ticket PDPs only) ------------------
   Collection pages: intentionally NOT injected — the fit-check tile and
   the Space Requirements Guide's "Ask a Sim Expert" CTA cover it there. */
(function () {
  function init() {
    try {
      if (document.querySelector('.bn-expert')) return;
      var isHighTicket = false;
      var priceEl = document.querySelector('.bpdp-price [data-bpdp-price-current]');
      if (priceEl) {
        var m = (priceEl.textContent || '').replace(/,/g, '').match(/([0-9]+(?:\.[0-9]+)?)/);
        isHighTicket = !!(m && parseFloat(m[1]) >= 3100);
      }
      if (!isHighTicket) return;
      var el = document.createElement('div');
      el.className = 'bn-expert';
      el.innerHTML =
        '<div class="bn-expert__copy">' +
        '<div class="bn-expert__title">Need help picking a golf simulator?</div>' +
        '<div class="bn-expert__sub">Talk to a sim specialist \u2014 free, no pressure</div>' +
        '</div>' +
        '<a class="bn-expert__btn" href="/pages/contact">Ask an Expert</a>';
      var anchor = document.querySelector('.bn-delivery') ||
                   document.querySelector('.bn-installments') ||
                   document.querySelector('.bpdp-price');
      if (!anchor) return;
      anchor.insertAdjacentElement('afterend', el);
    } catch (err) { /* fail-safe */ }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ---- 1j Register-your-device prompt (account order pages) --------- */
(function () {
  function init() {
    try {
      if (!/^\/account(\/|$)/.test(location.pathname)) return;
      if (!/\/orders?\//.test(location.pathname)) return;
      if (document.querySelector('.bn-register')) return;
      var main = document.getElementById('MainContent');
      if (!main) return;
      var el = document.createElement('div');
      el.className = 'bn-register';
      el.innerHTML =
        '<div class="bn-register__eyebrow">One more thing</div>' +
        '<div class="bn-register__title">Register your device</div>' +
        '<p class="bn-register__text">Activates your 2-year warranty and unlocks setup guides before it even arrives.</p>' +
        '<a class="bn-register__btn" href="/pages/register-device">Register in 30 seconds</a>';
      main.insertAdjacentElement('afterbegin', el);
    } catch (err) { /* fail-safe */ }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ---- Mega-menu value props: one proof line per category panel ------
   Fills the promo slot in the panel FOOTER row (left of the Shop-all
   button) for panels that have no promo_text set in the theme editor.
   A promo_text set in the editor always wins — this only fills panels
   that have none. No icon — plain uppercase text, styled by the
   .mega-menu-footer .mega-menu-promo rules in the header section. */
(function () {
  var PROMOS = {
    'launch-monitors': 'Tour-proven camera accuracy.',
    'gps': '38,000+ courses mapped worldwide.'
  };
  function init() {
    try {
      document.querySelectorAll('.mega-menu-dropdown').forEach(function (panel) {
        var key = panel.getAttribute('data-mega-panel');
        if (!PROMOS[key] || panel.querySelector('.mega-menu-promo')) return;
        var container = panel.querySelector('.container');
        if (!container) return;
        var el = document.createElement('div');
        el.className = 'mega-menu-promo';
        el.textContent = PROMOS[key];
        var footer = container.querySelector('.mega-menu-footer');
        if (footer) {
          /* The liquid renders an empty <span> placeholder when no promo is set */
          var ph = footer.querySelector('span');
          if (ph && !ph.textContent.trim() && !ph.children.length) {
            ph.replaceWith(el);
          } else {
            footer.insertAdjacentElement('afterbegin', el);
          }
        } else {
          container.appendChild(el);
        }
      });
    } catch (err) { /* fail-safe */ }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ---- 1k LCP boost: prioritize the first buy-box image ------------- */
(function () {
  function init() {
    try {
      var hero = document.querySelector('.bpdp-gallery img, .bpdp-media img, #MainContent img');
      if (!hero) return;
      var rect = hero.getBoundingClientRect();
      if (rect.top < window.innerHeight) {
        hero.setAttribute('fetchpriority', 'high');
        hero.setAttribute('loading', 'eager');
        hero.setAttribute('decoding', 'sync');
      }
    } catch (err) { /* fail-safe */ }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
